import * as React from 'react';
import { observer } from 'mobx-react';
import { PaymentMethod } from '../../../../commonv3/types/payments';

type PaymentMethodViewProps = {
  paymentMethod: PaymentMethod;
  installmentCount?: number;
};

/**
 * @deprecated REST API に依存したコンポーネントです。GraphQL APIと使用する場合は PaymentMethodView を使用してください。
 */
export const LegacyPaymentMethodView = observer(({ paymentMethod, installmentCount = 1 }: PaymentMethodViewProps) => {
  const getInstallmentSuffix = (count: number) => {
    return count > 1 ? `（${count}回払い）` : '';
  };

  switch (paymentMethod) {
    case 'credit_card':
      return <>クレジットカードでの支払い{getInstallmentSuffix(installmentCount)}</>;
    case 'transfer':
      return <>銀行口座での振込み{getInstallmentSuffix(installmentCount)}</>;
    default:
      return <>不明なお支払方法</>;
  }
});
